import { IconButton as MuiIconButton, CircularProgress } from '@mui/material';
import { IconButtonProps } from './IconButton.props';
import { useMemo } from 'react';

export const IconButton = ({
  loading = false,
  disabled,
  children,
  ...props
}: IconButtonProps) => {
  const loaderSize = useMemo(() => {
    return props.size === 's'
      ? 18
      : props.size === 'm'
        ? 20
        : props.size === 'l'
          ? 24
          : 26;
  }, [props.size]);

  return (
    <MuiIconButton disabled={disabled || loading} {...props}>
      {loading ? (
        <CircularProgress size={loaderSize} color="inherit" />
      ) : (
        children
      )}
    </MuiIconButton>
  );
};

export default IconButton;
